import { refetchMe } from './me'

export const getWorkflowMax = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/workflowmax',
        cancelToken
      })
    } catch (e) {
      return { integrationData: {} }
    }
  }
)

export const deleteWorkflowMax = cancelToken => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: 'integrations/workflowmax',
      cancelToken
    })
    await dispatch(getWorkflowMax())
    await dispatch(refetchMe())
  }
)

export const listWorkflowMax = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/workflowmax/list',
        cancelToken
      })
    } catch (e) {
      return { categories: [], staff: [] }
    }
  }
)

export const updateWorkflowMax = (integrationData, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'integrations/workflowmax',
      data: { integrationData },
      cancelToken
    })
    await dispatch(getWorkflowMax())
    await dispatch(refetchMe())
  }
)

export const getMailChimp = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/mailchimp',
        cancelToken
      })
    } catch (e) {
      return { integrationData: {} }
    }
  }
)

export const deleteMailChimp = cancelToken => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: 'integrations/mailchimp',
      cancelToken
    })
    await dispatch(getMailChimp())
    await dispatch(refetchMe())
  }
)

export const listMailChimp = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/mailchimp/list',
        cancelToken
      })
    } catch (e) {
      return []
    }
  }
)

export const updateMailChimp = (integrationData, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'integrations/mailchimp',
      data: { integrationData },
      cancelToken
    })
    await dispatch(getMailChimp())
    await dispatch(refetchMe())
  }
)

export const zapierGetApiKey = cancelToken => (
  (dispatch, getState, api) => api({
    method: 'get',
    apiPath: 'zapier/api-key',
    cancelToken
  })
)

export const unsplashSearch = (params, cancelToken) => (dispatch, getState, api) => api({
  method: 'get',
  apiPath: 'integrations/unsplash/search',
  params,
  cancelToken
})

export const unsplashDownload = (downloadLocation, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'post',
    apiPath: 'integrations/unsplash/download',
    data: { download_location: downloadLocation },
    cancelToken
  })
)

// Slack

export const getSlack = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/slack',
        cancelToken
      })
    } catch (e) {
      return { integrationData: {} }
    }
  }
)

export const deleteSlack = cancelToken => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: 'integrations/slack',
      cancelToken
    })
    await dispatch(getSlack())
    await dispatch(refetchMe())
  }
)

export const listSlack = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/slack/list',
        cancelToken
      })
    } catch (e) {
      return []
    }
  }
)

export const updateSlack = (integrationData, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'integrations/slack',
      data: { integrationData },
      cancelToken
    })
    await dispatch(getSlack())
    await dispatch(refetchMe())
  }
)

export const getMindbody = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/mindbody',
        cancelToken
      })
    } catch (e) {
      return { integrationData: {} }
    }
  }
)

export const deleteMindbody = cancelToken => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: 'integrations/mindbody',
      cancelToken
    })
    await dispatch(getMindbody())
    await dispatch(refetchMe())
  }
)

export const classesListMindbody = cancelToken => (
  async (dispatch, getState, api) => {
    try {
      return await api({
        method: 'get',
        apiPath: 'integrations/mindbody/classes',
        cancelToken
      })
    } catch (e) {
      return { categories: [], staff: [] }
    }
  }
)

export const updateMindbody = (integrationData, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'integrations/mindbody',
      data: { integrationData },
      cancelToken
    })
    await dispatch(getMindbody())
    await dispatch(refetchMe())
  }
)
